import { request } from "../_helpers/Auth";

const namespace = "/api";

export const getProjectsEstablishments = (_id) => {
    return request({
        url: namespace + "/projects/establishment/" + _id,
        method: "get",
    });
};

export const addProject = (establishment_id, payload) => {
    return request({
        url: namespace + "/establishment/" + establishment_id + "/project",
        method: "post",
        data: payload,
    });
};

export const editProject = (establishment_id, payload) => {
    return request({
        url: namespace + "/establishment/" + establishment_id + "/project/edit",
        method: "post",
        data: payload,
    });
};

export const getProject = (_id) => {
    return request({
        url: namespace + "/project/" + _id,
        method: "get",
    });
};

export const deleteProject = (_id) => {
    return request({
        url: namespace + "/project/" + _id,
        method: "delete",
    });
};